module.exports = global["application_chart_accuracySpeed"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./accuracy-speed.ts");